import { Box } from "@mui/material";
import { useState, useEffect } from "react";

const ProgressBar = ({ barWidth, isActive, id, prevWidth, isPlayerLoad }) => {
  const prevWidthFixed = prevWidth > 95 ? 100 : prevWidth;
  const [archivedWidth, setWidth] = useState(prevWidthFixed);

  useEffect(() => {
    setWidth(prevWidthFixed);
  }, [isPlayerLoad]);

  useEffect(() => {
    if (isActive.vId === id) {
      isActive.playing && setWidth(barWidth);
    } else {
      setWidth(prevWidthFixed);
    }
  }, [barWidth]);

  const progressStyle = {
    backgroundColor: "#d8d8d8",
    borderRadius: "0px 0px 5px 5px",
    height: "5px",
    width: "100%",
  };

  const progressDoneStyle = {
    color: "#FFFFFF",
    background: "linear-gradient(to left, #2E117F, #5315BC)",
    boxShadow: "0 3px 3px -5px #2E117F, 0 2px 5px #5315BC",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "0px 0px 5px 5px",
    height: "100%",
    width: archivedWidth + "%",
    transition: "1s ease",
  };

  return (
    <Box sx={progressStyle}>
      <Box sx={progressDoneStyle}></Box>
    </Box>
  );
};

export default ProgressBar;
